import store from 'redux/store';
import { session__count_online } from 'redux/actions/sessions';

import {
  reports__get_statictics,
  reports__active_new,
  reports__action_fulfilled,
  reports__actives_read_done,
  reports__actives_unread_done,
  reports__actives_delete_done,
  reports__archived_unbox_done
} from 'redux/actions/reports';
import {
  summons__get_statictics,
  summons__get_issued,
  summon_approveSuccessful,
  summon_archiveSuccessful
} from 'redux/actions/summons';
import { tracker__get_started } from 'redux/actions/trackers';
import { tours__get_todayCount } from 'redux/actions/tours';

let storage = JSON.parse(localStorage.getItem('guardexpert_logon'));
const autoreload = true;

let watchDog = setTimeout(() => {
  //console.log('Watch Dog timer triggered!')
  storage = JSON.parse(localStorage.getItem('guardexpert_logon'));
  if (!storage) {
    return;
  }
  if (autoreload) window.location.reload(true);
}, 60000);

export function mqtt_handlers(topic, payload) {
  //console.log(topic, JSON.parse(payload));
  if (topic === 'heartbeat') {
    //console.log('Watch Dog timer reset')
    if (!watchDog) {
      watchDog = setTimeout(() => {
        //console.log('Watch Dog timer triggered!')
        storage = JSON.parse(localStorage.getItem('guardexpert_logon'));
        if (!storage) {
          return;
        }
        if (autoreload) window.location.reload(true);
      }, 60000);
    } else {
      clearTimeout(watchDog);
      watchDog = setTimeout(() => {
        //console.log('Watch Dog timer triggered!')
        storage = JSON.parse(localStorage.getItem('guardexpert_logon'));
        if (!storage) {
          return;
        }
        if (autoreload) window.location.reload(true);
      }, 60000);
    }
  }


  let splittedTopic = topic.split('/');
  let mainTopic = splittedTopic[1];
  let msgTarget = splittedTopic[0];

  storage = JSON.parse(localStorage.getItem('guardexpert_logon'));
  if (!storage.info) {
    return;
  }

  if (splittedTopic[0] === 'TOUR' || splittedTopic[0] === 'PANIC') {
    mainTopic = splittedTopic[0];
  }
  else if (msgTarget !== `${storage.info.userId}` && msgTarget !== `BROADCAST`) {
    return;
  }


  //console.log(`============ redux.actions.mqtt > ${topic} ?USER: ${storage.info.userId} > \n`, JSON.parse(payload))
  //console.log(`============ redux.actions.mqtt`)
  switch (mainTopic) {
    case 'DEVICE':
      sessions_receiver(topic, JSON.parse(payload));
      break;
    case 'REPORT':
      reports_receiver(topic, JSON.parse(payload));
      break;
    case `SUMMON`:
      summons_receiver(topic, JSON.parse(payload));
      break;
    case `TOUR`:
      tours_receiver(topic, JSON.parse(payload));
      break;
    case `PANIC`:
      panics_receiver(topic, JSON.parse(payload));
      break;
    default:
  }
}

function sessions_receiver(topic) {
  storage = JSON.parse(localStorage.getItem('guardexpert_logon'));
  let id = storage.info.userId;
  switch (topic) {
    case `BROADCAST/DEVICE/LOGIN`:
    case `${id}/DEVICE/LOGIN`:
      store.dispatch(session__count_online());
      break;
    case `BROADCAST/DEVICE/LOGOUT`:
    case `${id}/DEVICE/LOGOUT`:
      store.dispatch(session__count_online());
      break;
    default:
  }
}

function reports_receiver(topic, payload) {
  storage = JSON.parse(localStorage.getItem('guardexpert_logon'));
  let id = storage.info.userId;
  /*eslint-disable no-fallthrough*/
  switch (topic) {
    case `BROADCAST/REPORT/NEW`:
    case `${id}/REPORT/NEW`:
      store.dispatch(reports__get_statictics());
      store.dispatch(reports__active_new(payload));
      break;

    case `BROADCAST/REPORT/ACTION`:
    case `${id}/REPORT/ACTION`:
      store.dispatch(reports__action_fulfilled(payload));
      break;
    default:

    case `BROADCAST/REPORT/READ`:
    case `${id}/REPORT/READ`:
      //console.log("REPORT/READ :/n", payload)
      store.dispatch(reports__actives_read_done(payload));
      break;

    case `BROADCAST/REPORT/UNREAD`:
    case `${id}/REPORT/UNREAD`:
      //console.log("REPORT/UNREAD :/n", payload)
      store.dispatch(reports__actives_unread_done(payload));
      break;

    case `BROADCAST/REPORT/ARCHIVED`:
    case `${id}/REPORT/ARCHIVED`:
      //console.log("REPORT/ARCHIVED :/n", payload)
      store.dispatch(reports__actives_delete_done(payload));
      break;

    case `BROADCAST/REPORT/UNARCHIVED`:
    case `${id}/REPORT/UNARCHIVED`:
      console.log("REPORT/UNARCHIVED :/n", payload)
      store.dispatch(reports__archived_unbox_done(payload));
      break;
  }
}

function summons_receiver(topic, payload) {
  storage = JSON.parse(localStorage.getItem('guardexpert_logon'));
  let id = storage.info.userId;

  switch (topic) {
    case 'BROADCAST/SUMMON/NEW':
    case `${id}/SUMMON/NEW`:
      store.dispatch(summons__get_statictics());
      store.dispatch(summons__get_issued(0, 10));
      break;

    case 'BROADCAST/SUMMON/ARCHIVED':
    case `${id}/SUMMON/ARCHIVED`:
      store.dispatch(summon_archiveSuccessful(payload));
      break;

    case 'BROADCAST/SUMMON/APPROVED':
    case `${id}/SUMMON/APPROVED`:
      store.dispatch(summon_approveSuccessful(payload));
      break;

    case 'BROADCAST/SUMMON/REJECTED':
    case `${id} /SUMMON/REJECTED`:
      //console.log(`SUMMON/REJECTED > \n`, payload)
      break;

    case 'BROADCAST/SUMMON/DELETE':
    case `${id}/SUMMON/DELETE`:
      //console.log(`SUMMON/DELETE > \n`, payload)
      break;
    default:
  }
}

function tours_receiver(topic, payload) {
  switch (topic) {
    case `TOUR/START`:
      __dispatch_tour_start(payload.tracker_id);
      break;
    case `TOUR/POSITION`:
      __dispatch_tour_route(payload);
      break;
    case `TOUR/STOP`:
      __dispatch_tour_stop(payload.tracker_id);
      store.dispatch(tours__get_todayCount());
      break;
    case `TOUR/POINT/${payload.tracker_id}`:
      __dispatch_tour_visited(payload);
      break;
    default:
  }
}

function panics_receiver(topic, data) {
  let state;
  let trackerId;
  switch (topic) {
    case `PANIC/START`:
      state = data.state;
      trackerId = data.tracker_id;
      __dispatch_panic_start(trackerId, state);
      break;
    case `PANIC/POSITION`:
      __dispatch_panic_route(data);
      break;
    case `PANIC/STOP`:
      trackerId = data.tracker.id;
      __dispatch_panic_stop(trackerId);
      break;
    default:
  }
}

/**====================================================
 *                INTERNAL DISPATCHERS
 **====================================================
 */

function __dispatch_tour_start(trackerId) {
  store.dispatch(tracker__get_started(trackerId));
}
function __dispatch_tour_stop(trackerId) {
  store.dispatch({
    type: 'TRACKERS_TOUR_END',
    payload: {
      data: trackerId,
      error: null
    }
  });
}
function __dispatch_tour_route(payload) {
  store.dispatch({
    type: 'TRACKERS_TOUR_ROUTE',
    payload: {
      data: payload,
      error: null
    }
  });
}
function __dispatch_tour_visited(state) {
  store.dispatch({
    type: 'TRACKERS_TOUR_VISITED',
    payload: {
      data: state,
      error: null
    }
  });
}

function __dispatch_panic_start(trackerId, state) {
  if (!state.tracker[trackerId].isTour) {
    return store.dispatch(tracker__get_started(state.tracker[trackerId].id));
  }
  store.dispatch({
    type: 'TRACKERS_PANIC_START',
    payload: {
      data: { info: state, trackerId: trackerId },
      error: null
    }
  });
}
function __dispatch_panic_stop(trackerId) {
  //console.log("__dispatch_panic_stop > trackerId:", trackerId)
  store.dispatch({
    type: 'TRACKERS_PANIC_STOP',
    payload: {
      data: trackerId,
      error: null
    }
  });
}
function __dispatch_panic_route(data) {
  //console.log("__dispatch_panic_route > data:", data)
  store.dispatch({
    type: 'TRACKERS_TOUR_ROUTE',
    payload: {
      data: data,
      error: null
    }
  });
}



// WEBPACK FOOTER //
// ./src/redux/actions/mqtt.js